"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = __importDefault(require("md5"));
var utils_1 = require("../../utils");
exports.default = (function (transparent48) { return function (data) {
    var frame = ['48', '15', '03', '00'];
    var randomKey = data.randomKey;
    var _a = transparent48.virtual.device, devPriKey = _a.devPriKey, devTid = _a.devTid;
    frame.push.apply(frame, utils_1.splitByLength(md5_1.default("" + randomKey + devTid + devPriKey)));
    return frame;
}; });



// WEBPACK FOOTER //
// ./src/transparent48/encode/3.ts